<template>
	<div class="own-box display-flex flex-wrap text-align-center" v-on="$listeners">
		<div class="flex-center--end flex-col-12"><SIcon name="plus-create-new" /></div>
		<div class="flex-col-12"><h3 class="reg">Create your own</h3></div>
	</div>
</template>

<script>
export default {
	name: 'CreateYourOwnBox',
};
</script>

<style lang="scss" scoped>
.own-box {
	border: 2px dashed #dbe0e7;
	background: #fbfcfd;
	h3 {
		color: var(--signup-grey);
	}
}
</style>
